export default __webpack_public_path__ + "static/media/death-fly.c9972363.svg";